import {NotificationService} from "../../services/NotificationService";
import {ApplicationSettingService} from "../../services/ApplicationSettingService";
import {LocationService} from "../../services/LocationService";
import {FixedVTagService} from "../../services/FixedVTagService";
import {FixedVTag} from "../../entities/FixedVTag";
import {Location} from "../../entities/Location";
import {PagingModel} from "../paging/PagingModel";

export class CmdCenterSetPositionFixedModel extends PagingModel<FixedVTag> {
    static $inject = ['$q','FixedVTagService','LocationService','ApplicationSettingService','NotificationService'];
    selectedLocation:Location;
    locations:Location[] = [];
    selectedFixed:FixedVTag;
    VTAGTYPEVTAG = "VTag";
    VTAGTYPEVTAGGPS = "VTag GPS";
    vTagTypes:string[] = ["", "VTag", "VTag GPS"];
    selectedVTagType:string = "";
    fixedTagID:string = "";
    fixedTagName:string = "";
    errorMessage:string = "";
    positionTypes:string[] = ["Fixed"];
    selectedPositionType:string = "Fixed";
    feetPerMeter:number = 3.28084;
    x:number;
    y:number;
    z:number;
    measureType:string;
    useMeters:boolean;
    constructor($q:ng.IQService,
                public pagingService:FixedVTagService,
                public locationService:LocationService,
                public applicationSettingService:ApplicationSettingService,
                public notifyService:NotificationService) {
        super($q, pagingService, notifyService);
    }
    init(x:number,y:number,z:number){
        console.log("1x="+this.x+",y="+this.y+". fpm="+this.feetPerMeter);
        this.applicationSettingService.getCached().then((data)=>{
            this.useMeters = data.useMeters;
            if(!this.useMeters){
                this.x = x * this.feetPerMeter;
                this.y = y * this.feetPerMeter;
            }
            else{
                this.x = x ;
                this.y = y ;
            }
            this.z = z;
            console.log("2x="+this.x+",y="+this.y+". fpm="+this.feetPerMeter);
            this.measureType = this.useMeters ? "meters" : "feet";
        });
        this.refreshLocations();
    }
    refreshLocations():void{
      this.locationService.getAll().then((locs)=>{
        var originalSelected = this.selectedLocation;
        this.locations= locs;
        if(originalSelected != null)
          this.selectedLocation = originalSelected;
        else if(locs.length > 0)
          this.selectedLocation = locs[0];
      });
    }
    entityName():string{
        return "fixedvtag";
    }
    displayName():string{
        return "Fixed VTags";
    }
    getColumnDefs():ng.IPromise<void>{
      this.nameValuePairs =
        [
          ['name', 'Name', 150],
          ['vTagID', 'V-Tag ID', 100],
          ['locationName', 'Location', 120]
        ];
      return this.$q.when();
    }
    selectionChanged():void{
        if(this.selectedItems.length > 0) {
          this.selectedFixed = this.selectedItems[0];
          this.fixedTagID = this.selectedFixed.vTagID;
          this.fixedTagName = this.selectedFixed.name;
          //go through locations list and select correct one
          for(var i=0; i< this.locations.length;i++){
            var currLoc = this.locations[i];
            if(currLoc.id == this.selectedFixed.locationID){
              this.selectedLocation = currLoc;
              break;
            }
          }
        }
        else {
          this.selectedFixed = null;
          this.fixedTagID = null;
        }
        //alert("new sel changed asset null ?" +this.selectedAsset);
    }
}
